<template>
  <div v-if="!isEmpty" class="cart__head">
    <div class="cart__head-text">
      <span v-if="!hasFreeShipping" class="text-base" v-html="unlockShippingText"></span>
      <div v-if="cartData.enableGiftWithPurchase" class="cart__free-gift">
        <span v-if="hasFreeShipping && !hasFreeGift" class="text-base" v-html="unlockFreeGiftText"></span>
        <span v-if="hasFreeGift" v-html="cartData.gift_text_html"></span>
      </div>
      <span v-else-if="hasFreeShipping">Nice! You've got FREE SHIPPING!</span>
    </div>
    <div class="cart__close-icon" @click="emit('toggle-cart',false)" >
      <svg class="icon icon--xs">
        <use href="#exit"></use>
      </svg>
    </div>
    <div class="cart__shipping-bar">
      <div class="cart__shipping-progess-wrapper">
        <progress max="100" :value="freeShippingPercentComplete" class="cart__shipping-progess"></progress>
      </div>
      <div class="cart__shipping-progess-point --start --active"></div>
      <div class="cart__shipping-progess-point --shipping" :class="{'--active': hasFreeShipping}">
        <svg><use href="#shipping"></use></svg>
      </div>
      <div v-if="cartData.enableGiftWithPurchase" class="cart__shipping-progess-point --gift" :class="{'--active': hasFreeGift}">
        <svg><use href="#giveaway"></use></svg>
      </div>
    </div>
  </div>
  <div v-else class="cart__head-empty">
    <div class="cart__head-text">
      <h2>Your cart is empty</h2>
      <p>You deserve the best plant-based nutrition in the world, so fill your cart with some amazing products.</p>
    </div>
    <div class="cart__close-icon" @click="emit('toggle-cart',false)" >
      <svg class="icon icon--xs">
        <use href="#exit"></use>
      </svg>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, toRefs } from 'vue';

  const props = defineProps({
    isEmpty: {
      type: Boolean,
      default: false
    },

    cartData: {
      type: Object,
      default: ({})
    },

    cartTotal: {
      type: Number,
      default: 0
    },

    hasFreeShipping: {
      type: Boolean,
      default: false
    },

    hasFreeGift: {
      type: Boolean,
      default: false
    },

    freeShippingMin: {
      type: Number,
      default: 0
    },

    freeGiftMin: {
      type: Number,
      default: 0
    }
  })

  const { cartData, cartTotal, freeShippingMin, freeGiftMin } = toRefs(props)
  const emit = defineEmits(['toggle-cart'])

  const unlockShippingText = computed(() => {
    const freeShippingRemaining = freeShippingMin.value - cartTotal.value;
    const inputString = /\[\{\{\{ remaining \}\}\}\]/g;

    return cartData.value.to_unlock_shipping.replace(inputString, formatPrice(freeShippingRemaining));
  })

  const unlockFreeGiftText = computed(() => {
    const freeGiftRemaining = freeGiftMin.value - cartTotal.value;
    const inputString = /\[\{\{\{ remaining \}\}\}\]/g;

    return cartData.value.to_unlock_gift_html.replace(inputString, formatPrice(freeGiftRemaining));
  })

  const freeShippingPercentComplete = computed(() => {
    if (!cartData.value.enableGiftWithPurchase) {
      return Math.min(100, Math.max(0, (cartTotal.value / freeShippingMin.value) * 100));
    }

    const shippingPercentage = Math.min(50, (cartTotal.value / freeShippingMin.value) * 50);
    const freeGiftPercentage = (shippingPercentage === 50) ? Math.min(50, (cartTotal.value / freeGiftMin.value) * 100 - 50) : 0;
    
    return Math.min(100, Math.max(0, shippingPercentage + freeGiftPercentage));
  });

  const formatPrice = (price) => {
    return window.formattedPrice(price/100)
  }
</script>